import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import { isDate } from "util";
import { DEFAULT_SEARCH_KEY } from "../filterBar/utils";
var stringExactMatch = function (value, filter) {
  var _context;
  return _includesInstanceProperty(_context = value.toLowerCase()).call(_context, filter.toLowerCase());
};
function formatDataItem(key, value, formatters) {
  return formatters[key] ? formatters[key](value) : value.toString();
}
export var dataFilter = function (data, filters) {
  var options = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    _options$searchKey = options.searchKey,
    searchKey = void 0 === _options$searchKey ? DEFAULT_SEARCH_KEY : _options$searchKey,
    _options$formatters = options.formatters,
    formatters = void 0 === _options$formatters ? {} : _options$formatters,
    filterKeys = _Object$keys(filters);
  return _filterInstanceProperty(data).call(data, function (dataItem) {
    return filterKeys.every(function (filterKey) {
      var filter = filters[filterKey];
      if (filterKey === searchKey) return _Object$entries(dataItem).some(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        return stringExactMatch(formatDataItem(key, value, formatters), filter);
      });
      if (Array.isArray(filter)) return _includesInstanceProperty(filter).call(filter, dataItem[filterKey]);
      if (null != filter && filter.min || null != filter && filter.max) {
        var min = filter.min,
          max = filter.max;
        return min ? max ? dataItem[filterKey] >= min && dataItem[filterKey] <= max : dataItem[filterKey] >= min : dataItem[filterKey] <= max;
      }
      if (isDate(filter) || "number" == typeof filter) return dataItem[filterKey] === filter;
      if ("function" == typeof filter) return filter(dataItem[filterKey]);
      if (null != filter && _startsWithInstanceProperty(filter).call(filter, ">") || null != filter && _startsWithInstanceProperty(filter).call(filter, "<")) {
        var prefix = filter[0],
          rest = filter.substr(1);
        "=" === rest[0] && (prefix += "=", rest = rest.substr(1));
        var value = Number(rest);
        switch (prefix) {
          case "<=":
            return dataItem[filterKey] <= value;
          case ">=":
            return dataItem[filterKey] >= value;
          case ">":
            return dataItem[filterKey] > value;
          case "<":
            return dataItem[filterKey] < value;
          default:
            return !0;
        }
      }
      return "string" != typeof filter || stringExactMatch(dataItem[filterKey].toString(), filter);
    });
  });
};